module.exports = __webpack_public_path__ + "img/logout-two.8ab36a4e.png";